import React from 'react';

import LinkButton from '../../buttons/LinkButton';
import { formatToSimpleDateTime, showToast } from '../../../../helpers';
import { icons } from '../../../../helpers/icons';
import { DEFAULT_ERROR_MESSAGE } from '../../../../helpers/constants';
import { downloadCertificate } from '../../../../requests';
import { downloadCertificatePDF } from '../../../../helpers/downloadHelper';
import { CourseType } from '../../../../types';

interface IClassDetails {
  id?: string; // Registration ID for certificate download
  startTime: string;
  name: string;
  description?: string;
  readingMaterialLink?: string;
  attended?: boolean; // To check if user attended the class
  courseType: CourseType;
  isParent: boolean;
}

const ClassDetails: React.FC<IClassDetails> = ({
  id,
  startTime,
  name,
  description,
  readingMaterialLink,
  attended,
  courseType,
  isParent,
}) => {
  const handleDownloadCertificate = async () => {
    if (id) {
      try {
        await downloadCertificatePDF(id, name, downloadCertificate);
      } catch (error) {
        console.error('Error downloading certificate:', error);
        showToast(DEFAULT_ERROR_MESSAGE, 'error');
      }
    }
  };

  let showCertificateDownload = id && attended;

  // is cohort/series item then download only if parent course
  if (courseType === CourseType.cohort || courseType === CourseType.series) {
    showCertificateDownload = id && isParent;
  }

  return (
    <div className="flex flex-col">
      <div className="font-medium uppercase text-blue-primary">
        {formatToSimpleDateTime(startTime)}
      </div>
      <div className="xl:w-[26rem] 3xl:w-[30rem] text-heading-dark whitespace-normal">
        {name}
      </div>
      <div className="xl:w-[26rem] 3xl:w-[30rem] text-sm md:text-regular text-grey-700 font-medium">
        {description}
      </div>
      <div className="flex flex-col justify-end gap-2 md:gap-4 md:flex-row">
        {showCertificateDownload && (
          <LinkButton
            text="Download Certificate"
            icon={icons.download}
            onClick={handleDownloadCertificate}
          />
        )}
        {readingMaterialLink && (
          <LinkButton
            text="Class reading material"
            icon={icons.book}
            href={readingMaterialLink}
          />
        )}
      </div>
    </div>
  );
};

export default ClassDetails;
